export const initialTransactions = [
  { id: 1, date: '2026-04-01', description: 'Monthly PG Rent', amount: 8500, category: 'Housing', type: 'expense' },
  { id: 2, date: '2026-04-02', description: 'Internship Stipend', amount: 15000, category: 'Income', type: 'income' },
  { id: 3, date: '2026-04-03', description: 'Cloud Computing Course', amount: 1200, category: 'Education', type: 'expense' },
  { id: 4, date: '2026-04-04', description: 'Swiggy/Zomato', amount: 450, category: 'Food', type: 'expense' },
  { id: 5, date: '2026-04-05', description: 'Metro Recharge', amount: 500, category: 'Transport', type: 'expense' },
];

export const chartData = [
  { name: 'Mon', income: 0, expense: 8500 },
  { name: 'Tue', income: 15000, expense: 0 },
  { name: 'Wed', income: 0, expense: 1200 },
  { name: 'Thu', income: 0, expense: 450 },
  { name: 'Fri', income: 0, expense: 500 },
];